import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getWithExpiry, setWithExpiry } from "../../common";
import CourseProgress from "../CourseProgress";
import { useTranslation } from "react-i18next";
import BoardInstructions from "../BoardInstructions";
import configVars from "../../config";
import { StickyContainer, Sticky } from "react-sticky";

const BoardGuide = () => {
  const { board_id } = useParams();
  const [courseImage, setCourseImage] = useState("");
  const [lessonContent, setLessonContent] = useState("");
  const [topics, setTopics] = useState([]);
  const [translation] = useTranslation("translations");
  const [loading, setLoading] = useState(false);
  // const [selectedLesson, setSelectedLesson] = useState('');
  // const [selectedTopic, setSelectedTopic] = useState('');

  //const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  useEffect(() => {
    if (!board_id) return;

    const boardGuides = getWithExpiry(`sy_board_${board_id}_guides`);
    // const recentLesson = getWithExpiry( 'recent_visited_lesson' );
    // const recentTopic = getWithExpiry( 'recent_visited_topic' );

    // if ( recentLesson ) {
    //     setSelectedLesson(recentLesson);
    // }

    // if ( recentTopic ) {
    //     setSelectedTopic( recentTopic );
    // }

    if (boardGuides) {
      const firstLesson = boardGuides[Object.keys(boardGuides)[0]];

      const lessonData = Object.keys(boardGuides)
        .filter((l) => boardGuides[l].name === firstLesson.name)
        .map((l) => boardGuides[l]);

      if (!lessonData[0]) return;

      setCourseImage(lessonData[0].course_image);
      setLessonContent(lessonData[0].content);
      setTopics(lessonData[0].topics);
      //setSelectedLesson(firstLesson.name);
    } else {
      (async () => {

        setLoading(true);

        const response = await fetch(
          `${configVars.apiUrl}sustainchange/v1/getboardguides/?boardid=${board_id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Basic ${configVars.auth}`,
            },
          }
        );

        const courseResponse = await response.json();

        if (courseResponse && courseResponse.data) {
          const responseData = courseResponse.data.data;

          setWithExpiry(`sy_board_${board_id}_guides`, responseData);

          if ( Object.keys(responseData) ) {
            const firstLesson = responseData[Object.keys(responseData)[0]];

            const lessonData = Object.keys(responseData)
              .filter((l) => responseData[l].name === firstLesson.name)
              .map((l) => responseData[l]);

            if (!lessonData[0]) return;

            setCourseImage(lessonData[0].course_image);
            setLessonContent(lessonData[0].content);
            setTopics(lessonData[0].topics);

            setLoading(false);
          }
          //setSelectedLesson(firstLesson.name);

          return;
        }

        setLoading(false);
      })();
    }
  }, [board_id]);

  return (
    <div className="col-12">

      { loading &&
          <div className="d-flex justify-content-center mt-5">
              <div className="spinner-border text-primary" role="status" >
              <span className="visually-hidden">Loading...</span>
              </div>
          </div>
      }

      {courseImage && (
        <div
          className="course-img-wrap d-flex overflow-hidden position-relative"
          style={{ maxHeight: "300px" }}
        >
          <img
            src={courseImage}
            alt="Lesson"
            className="w-100"
            style={{ objectFit: "cover" }}
          />
          <div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column">
            <div className="flex-grow-1 d-flex align-items-center">
              {/* <h1 className="text-white text-center">{lessonTitle}</h1> */}
            </div>
            <span className="text-white p-3 d-flex w-100 dark-overlay">
              <span className="text-white pe-3">
                <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
              </span>
              <Link to={`/board/${board_id}`} className="text-white">
                {translation("back_to_board")}
              </Link>
            </span>
          </div>
          {topics[0] && <CourseProgress topic={topics[0].ID} />}
          {!topics[0] && <CourseProgress />}
        </div>
      )}

      <StickyContainer>
        <div className="mx-auto mt-4" style={{ maxWidth: "1400px" }}>
          <div className="row justify-content-center">
          <div className="col-12 pt-lg-5 px-4">
            <div className="row">
              <div className="col-12 col-lg-3">
                <Sticky disableCompensation>
                  {({ style, isSticky }) => (
                    <div
                      style={style}
                      className={`${isSticky ? "instructions-is-sticky" : ""}`}
                    >
                      <BoardInstructions />
                    </div>
                  )}
                </Sticky>
              </div>
              <div className="col-12 col-lg-9">
                <div className="row">
                  <div className="col-12 px-3 px-lg-5">
                    <div className="text-lg" dangerouslySetInnerHTML={{ __html: lessonContent }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </StickyContainer>
    </div>
  );
};

export default BoardGuide;
